import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-column tw-items-center tw-pl-2 tw-px-4" }

import { computed, PropType } from "vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'SharedAlert',
  props: {
  type: {
    required: false,
    type: String as PropType<"info" | "warning" | "success" | "error">,
    default: "info",
  },
},
  setup(__props) {

const props = __props;

const classFromType = computed(() => {
  switch (props.type) {
    case "info":
      return "tw-bg-blue-600 tw-text-white";
    case "success":
      return "bg-success tw-text-white";
    case "warning":
      return "bg-warning tw-text-white";
    case "error":
      return "bg-red tw-text-white";
    default:
      return "";
  }
});

const iconFromType = computed(() => {
  switch (props.type) {
    case "info":
      return "fas fa-info-circle";
    case "error":
      return "fas fa-info-circle";
    case "warning":
      return "fas fa-exclamation-triangle";
    default:
      return "";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.$attrs, {
    class: ["tw-flex tw-rounded-md tw-p-2 tw-mb-4", classFromType.value]
  }), [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "icon", {}, () => [
        _createElementVNode("i", {
          class: _normalizeClass(iconFromType.value),
          style: {"font-size":"36px"}
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "body")
    ])
  ], 16))
}
}

})